import React from 'react'
import { connect } from 'react-redux'
import { withTranslation, WithTranslation } from 'react-i18next'
import Header from '../../Header'
import Footer from '../../Footer'
import { setUIForwardAction, setErrorAction, clearCurrentPageAction } from '../../../actions'
import { UI } from '../../../constants/ui'
import { AppState } from '../../../reducers'
import './confirmLicencePlate.less'
import FooterMobile from '../../FooterMobile'
import { getMode } from '../../../hooks/mode'
import { MODE } from '../../../constants/mode'

const mapDispatchToProps = {
  setUIForward: setUIForwardAction,
  setError: setErrorAction,
  clearCurrentPage: clearCurrentPageAction,
}
type DispatchProps = typeof mapDispatchToProps

const mapStateToProps = (state: AppState) => ({
  reservation: state.reservation.reservation,
})
type StateProps = ReturnType<typeof mapStateToProps>
type Props = DispatchProps & StateProps & WithTranslation
class ConfirmLicencePlate extends React.PureComponent<Props> {
  render() {
    const { setUIForward, reservation, clearCurrentPage } = this.props
    const licencePlate = (reservation && reservation.cargoUnit && reservation.cargoUnit.regNumber) || ''

    const mainButtonClick = () => {
      clearCurrentPage()
      setUIForward(UI.CONFIRM_RESERVATION)
    }

    const mode = getMode()

    if (mode === MODE.MOBILE) {
      return this.renderMobile(licencePlate, mainButtonClick)
    } else {
      return this.renderDesktop(licencePlate, mainButtonClick)
    }

  }

  renderDesktop(licencePlate: string, mainButtonClick: () => void) {
    const { t, setError } = this.props
    return (
      <>
        <Header />
        <div className="confirm-licence-plate">
          <div className="title" dangerouslySetInnerHTML={{ __html: t('confirmLicencePlateCorrect') }}></div>
          <div className="info">
            <div className="subtitle">{t('confirmLicencePlate')}</div>
            <div className="confirm-licence-plate-text">{licencePlate}</div>
          </div>
          <div className="confirm">
            <button className="cancel-button" onClick={() => setError('contactCargoCheckin', '')}>
              {t('no')}
            </button>
            <button className="main-button" onClick={() => mainButtonClick()}>
              {t('yes')}
            </button>
          </div>
        </div>
        <Footer />
      </>
    )
  }

  renderMobile(licencePlate: string, mainButtonClick: () => void) {
    const { t, setError } = this.props
    return (
      <div className="confirm-licence-plate-mobile">
        <div className="confirm-licence-plate-wrapper">
          <div className="title" dangerouslySetInnerHTML={{ __html: t('confirmLicencePlateCorrect') }}></div>
          <div className="info">
            <div className="subtitle">{t('confirmLicencePlate')}</div>
            <div className="confirm-licence-plate-text">{licencePlate}</div>
          </div>
          <div className="confirm">
            <button className="main-button-mobile" onClick={() => mainButtonClick()}>
              {t('yes')}
            </button>
            <button className="cancel-button-mobile" onClick={() => setError('contactCargoCheckin', '')}>
              {t('no')}
            </button>
          </div>
        </div>
        <div className="footer-mobile-container">
          <FooterMobile />
        </div>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(ConfirmLicencePlate))
